import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ASISTENCIAS_DIARIAS,
  ALL_ASISTENCIAS_DIARIAS,
  LOADING_ALL_ASISTENCIAS_DIARIAS,
  ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS,
} from './AsistenciasReducer';
import {
  allEstudiantesAsistenciasService,
  allAsistenciasService,
} from './AsistenciasService';

export const allAsistenciasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: true });
    const res = await allAsistenciasService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_ASISTENCIAS_DIARIAS, payload: res.data });
      dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const setActivoAsistenciasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ASISTENCIAS_DIARIAS, payload: data });
};

export const allEstudiantesAsistenciasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: true });
    const res = await allEstudiantesAsistenciasService(params);
    if (res.status === 200) {
      dispatch({
        type: ALL_ESTUDIANTES_ASISTENCIAS_DIARIAS,
        payload: res.data.data,
      });
      dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ASISTENCIAS_DIARIAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};
